import { ReebeloConditions } from '@lambda/reebelo';

export const SPOTLIGHT_DEALS_COUNT = 12;

/*
 * Needed to include null to all the attributes here because getServerSideProps transfer in json
 * If the value is undefined then the process of turning into JSON will result an error
 */

export type TopDealProduct = {
  productName: string | null;
  gid: string;
  title: string;
  price: number;
  comparePrice: number | null;
  imageUrl: string;
  condition: ReebeloConditions | null;
  productType: string | null;
  psku: string | null;
  ranking: number | null;
  tags: string[];
  handle: string;
  vendor: string | null;
  sku: string | null;
  color: string | null;
  brand: string | null;
  carrier: string | null;
  stock: number | null;
  storage: string | null;
  productId?: number | null;
  variantId?: number | null;
  key?: string | null;
  serviceProviders?: string[] | null;
  dealtypes?: string[] | null;
  dealStockLimit?: number | null;
  dealEndDate?: string | null;
  categories?: string[] | null;
  reebeloPk?: string;
};

export type Search = {
  filters: Partial<Record<string, string>>;
  page?: number;
  size: number;
  sort: 'ranking' | 'price' | undefined;
  order: 'asc' | 'desc';
};

export type SearchResultsOnlyDeals = {
  deals: TopDealProduct[];
  spotlightDeals?: TopDealProduct[];
  topCategories?: string[];
  count: number;
  hasNextPage: boolean;
  haslastMinuteDeals: number;
  hasBundleOffers: number;
};

export type DealsResults = SearchResultsOnlyDeals & {
  priceRange: { min: number; max: number };
  options: Partial<Record<string, Array<{ key: string; count: number }>>>;
};

export type HotDealCardContentT = {
  deal: TopDealProduct;
  isCollectionPage: boolean;
  isSpotlight: boolean;
};
